export default __webpack_public_path__ + "static/media/ic_app_switcher.8ca2c826.svg";